const menuBackButton = document.querySelector(".menu-drawer__back-button");
const l1Menus = document.querySelectorAll('[id^="menu-drawer__menu-item-l1"]');
const l2Menus = document.querySelectorAll('[id^="menu-drawer__menu-item-l2"]');
const closeButton = document.querySelector(".menu-drawer__close-button ");


function closeAnimation(detailsElement) {
  let animationStart;

  const handleAnimation = (time) => {
    if (animationStart === undefined) {
      animationStart = time;
    }

    const elapsedTime = time - animationStart;

    if (elapsedTime < 400) {
      window.requestAnimationFrame(handleAnimation);
    } else {
      detailsElement.removeAttribute('open');
      if (detailsElement.closest('details[open]')) {
        trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
      }
    }
  }

  window.requestAnimationFrame(handleAnimation);
}


function closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

menuBackButton.addEventListener('click', (event) => {
  menuBackButton.classList.add('clicked');
  let detailsElement;
  const classes = [...menuBackButton.classList];

  const l2MenuClicked = classes.find((value) => value.startsWith('l2-menu-clicked-'));
  if(l2MenuClicked) {
    const idx = l2MenuClicked.split('l2-menu-clicked-')[1];
    if(idx){
      detailsElement = document.querySelector(`#Details-menu-drawer-submenu-${idx}`);
      menuBackButton.classList.remove(`l2-menu-clicked-${idx}`);
    }
  } else {
    const idx = classes.find((value) => value.startsWith('l1-menu-clicked-'))?.split('l1-menu-clicked-')[1];
    if(idx) {
      detailsElement = document.querySelector(`#Details-menu-drawer-menu-item-${idx}`);
      menuBackButton.classList.remove(`l1-menu-clicked-${idx}`);
      menuBackButton.classList.add('hidden')
    }
  }
  closeSubmenu(detailsElement);
});

l2Menus.forEach(l2Menu => {
  l2Menu.addEventListener('click', (event) => {
    const idx = l2Menu.id.split('menu-drawer__menu-item-l2-')?.[1]
    menuBackButton.classList.add(`l2-menu-clicked-${idx}`)
  });
})

l1Menus.forEach(l1Menu => {
  l1Menu.addEventListener('click', (event) => {
    const idx = l1Menu.id.split('menu-drawer__menu-item-l1-')?.[1]
    menuBackButton.classList.add(`l1-menu-clicked-${idx}`)
    menuBackButton.classList.remove('hidden');
  })
})

closeButton.addEventListener('click', (event) => {
  menuBackButton.classList.add('hidden')
})
